import { Link } from "react-router-dom";
import { Instagram, MapPin, Mail, Phone } from "lucide-react";

const TIMMA = "https://timma.no/salong/medskin-by";

export const Footer = () => {
  return (
    <footer className="bg-[#2C2C2A] text-[#D9D0C5]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          <div className="md:col-span-4">
            <Link to="/" className="font-serif text-3xl md:text-4xl text-[#F7F6F3] tracking-tight">Medskinby</Link>
            <p className="mt-5 max-w-md text-sm md:text-base text-[#D9D0C5]/80 font-light leading-relaxed">
              En klinisk hudklinikk i Oslo. Medisinsk faglig forankring møter en rolig, helhetlig tilnærming til hudhelse.
            </p>
            <a
              href={TIMMA}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-8 inline-flex items-center bg-[#C4A981] text-[#2C2C2A] hover:bg-[#F7F6F3] transition-all duration-500 rounded-full px-7 py-3.5 text-xs uppercase tracking-[0.22em]"
              data-testid="footer-book-btn"
            >
              Book time
            </a>
          </div>

          <div className="md:col-span-2">
            <div className="text-[11px] uppercase tracking-[0.25em] text-[#C4A981] mb-5">Hudutfordringer</div>
            <ul className="space-y-3 text-sm text-[#D9D0C5]/90 font-light">
              <li><Link to="/hudutfordringer/akne-arr-uren-hud" className="hover:text-[#F7F6F3] transition-colors">Akne & arr</Link></li>
              <li><Link to="/hudutfordringer/sensitiv-hud" className="hover:text-[#F7F6F3] transition-colors">Sensitiv hud</Link></li>
              <li><Link to="/hudutfordringer/rosacea-inflammasjon" className="hover:text-[#F7F6F3] transition-colors">Rosacea</Link></li>
              <li><Link to="/hudutfordringer/hudbarriere" className="hover:text-[#F7F6F3] transition-colors">Hudbarriere</Link></li>
              <li><Link to="/hudutfordringer/hormonell-ubalanse" className="hover:text-[#F7F6F3] transition-colors">Hormonell</Link></li>
              <li><Link to="/hudutfordringer/anti-age-hudfornyelse" className="hover:text-[#F7F6F3] transition-colors">Anti-age</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] uppercase tracking-[0.25em] text-[#C4A981] mb-5">Behandlinger</div>
            <ul className="space-y-3 text-sm text-[#D9D0C5]/90 font-light">
              <li><Link to="/behandlinger/hydrafacial" className="hover:text-[#F7F6F3] transition-colors">Hydrafacial</Link></li>
              <li><Link to="/behandlinger/dermapen" className="hover:text-[#F7F6F3] transition-colors">Dermapen</Link></li>
              <li><Link to="/behandlinger/microneedling" className="hover:text-[#F7F6F3] transition-colors">Microneedling</Link></li>
              <li><Link to="/behandlinger/profhilo" className="hover:text-[#F7F6F3] transition-colors">Profhilo</Link></li>
              <li>
                <a href={TIMMA} target="_blank" rel="noopener noreferrer" className="hover:text-[#F7F6F3] transition-colors">
                  Alle behandlinger →
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] uppercase tracking-[0.25em] text-[#C4A981] mb-5">Kontakt</div>
            <ul className="space-y-4 text-sm text-[#D9D0C5]/90 font-light">
              <li className="flex items-start gap-3">
                <MapPin size={15} strokeWidth={1.2} className="mt-0.5 text-[#C4A981]" />
                <span>Schønings gate 2b<br />Oslo, Norge</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={15} strokeWidth={1.2} className="text-[#C4A981]" />
                <a href="tel:+4794112977" className="hover:text-[#F7F6F3] transition-colors" data-testid="footer-phone">+47 941 12 977</a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={15} strokeWidth={1.2} className="text-[#C4A981]" />
                <a href="mailto:post@medskinby.no" className="hover:text-[#F7F6F3] transition-colors" data-testid="footer-email">post@medskinby.no</a>
              </li>
              <li className="flex items-center gap-3">
                <Instagram size={15} strokeWidth={1.2} className="text-[#C4A981]" />
                <a
                  href="https://instagram.com/medskin.by"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-[#F7F6F3] transition-colors"
                  data-testid="footer-instagram"
                >
                  @medskin.by
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#4A4238] flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-xs text-[#D9D0C5]/60 font-light tracking-wide">
            © {new Date().getFullYear()} Medskinby · Org. 933 862 887
          </p>
          <p className="text-xs text-[#D9D0C5]/60 font-light tracking-wide">
            Personvern · Vilkår · Cookies
          </p>
        </div>
      </div>
    </footer>
  );
};
